<template>
  <IMenu placement="bottom-end" width="124">
    <template #link>
      <p :class="$style.label"><SvgIcon :svg="SortSvg" width="13" />{{ label }}</p>
    </template>
    <template #menu>
      <ul :class="$style.menu">
        <li v-for="item in list" :key="item.text" :class="[item.sort === sort ? $style.active : '']">
          <a :href="link(item.sort)">{{ item.text }}</a>
        </li>
      </ul>
    </template>
  </IMenu>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import IMenu from '@/js/components/molecules/IMenu.vue';
import SvgIcon from '@/js/components/molecules/SvgIcon.vue';
import SortSvg from '@/svgs/vue/sort.svg';

const props = defineProps<{
  sort: string;
}>();
const list = [
  {
    sort: 'inshop',
    text: '注目順',
  },
  {
    sort: 'newer',
    text: '新しい順',
  },
  {
    sort: 'older',
    text: '古い順',
  },
  {
    sort: 'view',
    text: '閲覧数順',
  },
  {
    sort: 'lower',
    text: '価格が安い順',
  },
  {
    sort: 'higher',
    text: '価格が高い順',
  },
];
const link = computed(() => (sort: string) => {
  const params = new URLSearchParams(location.search);
  params.set('sort', sort);
  return `?${params.toString()}`;
});
const label = computed(() => list.find((item) => item.sort === props.sort)?.text || '');
</script>

<style module lang="scss">
.label > svg {
  margin-right: 6px;
  position: relative;
  top: 1px;
}

.menu {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 6px;

  li {
    &.active {
      font-weight: bold;
    }

    a {
      color: inherit;

      &:hover {
        text-decoration: none;
      }
    }
  }
}
</style>
